import { Component, EventEmitter, inject, Input, Output } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatCardModule } from "@angular/material/card";
import { MatButtonModule } from "@angular/material/button";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIcon } from "@angular/material/icon";
import { MatDialog, MatDialogModule } from "@angular/material/dialog";
import { MatSidenav, MatSidenavModule } from "@angular/material/sidenav";
import { MatIconModule } from "@angular/material/icon";
import { LayoutModule } from "@angular/cdk/layout";
import { MatListModule } from "@angular/material/list";
import { AppIconPaths } from "src/app/shared/common/app-icon.path";
import { OKTA_AUTH } from "@okta/okta-angular";
import OktaAuth from "@okta/okta-auth-js";

import { UsersService } from "src/app/api/users.service";
import { GlobalServiceService } from "src/app/shared/services/global-service.service";
import {
  ExternalUserRegistrationComponent,
  UserRegistrationDialogData,
} from "src/app/Pages/external-user-registration/external-user-registration.component";
import { UserTypeSelectionModalComponent } from "./user-type-selection-modal-component/user-type-selection-modal-component.component";
import { InternalUserRegistrationComponent } from "src/app/Pages/login/internal-user-registration/internal-user-registration.component";  
import {InteruserRegistrationFormComponent} from "src/app/Pages/login/internal-user-registration/interuser-registration-form/interuser-registration-form.component";
import { RouterLink } from "@angular/router";
import {UserTypeEnum} from 'src/app/shared/common/common.enum';
import {
  AppRoutePaths,
  AppRoutes,
} from "src/app/shared/common/app-path.routes";

@Component({
  selector: "app-header",
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatToolbarModule,
    MatIcon,
    MatIconModule,
    MatSidenavModule,
    LayoutModule,
    MatListModule,
    MatDialogModule,
  ],
  templateUrl: "./header.component.html",
  styleUrl: "./header.component.css",
})
export class HeaderComponent {
  // private gb = inject(GlobalServiceService);
   userType: string = '';
  constructor(private dialog: MatDialog) {}


  loading = false;
  @Input() isMobile = false;
  @Input() drawer!: MatSidenav;
  @Output() openExtRegistration = new EventEmitter<boolean>(false);
  appIconPaths = AppIconPaths;
  okta = inject<OktaAuth>(OKTA_AUTH);
  appRoutes = AppRoutes;
  appRoutePaths = AppRoutePaths;

  onLogout() {
    this.oktaSignout();
  }

  ngOnInit() {  
    this.userType = sessionStorage.getItem("UserType") || '';
  }

  private oktaSignout() {
    this.okta.clearStorage();
    sessionStorage.clear();
    localStorage.clear();
    this.okta.clearDPoPStorage(true);
    this.okta.closeSession();
    this.okta.signOut();
  }
  // async signOut() {
  //   this.okta.clearStorage();
  //   this.okta.clearDPoPStorage(true);
  //   this.okta.closeSession();
  //   this.okta.signOut({
  //     postLogoutRedirectUri: `http://localhost:4200/${
  //       AppRoutePaths[AppRoutes.Login]
  //     }`,
  //   });
  // }

  private getEmailFromSession(): string {
    return sessionStorage.getItem("UserEmail") ?? "";
  }

  // clickExtRegistration() {
  //   this.openExtRegistration.emit(true);
  // }
  clickExtRegistration(userType: string): void {
    
    if (userType === 'External') {
      // Directly open the external user registration modal
      this.openExtRegistration.emit(true);
      // this.dialog.open(ExternalUserRegistrationComponent, {
      //   width: '600px',
      //   height: 'auto',
      //   disableClose: true,
      // });
    } else if (userType === 'Internal') {
      // Open the modal with radio buttons for internal users
      const dialogRef = this.dialog.open(UserTypeSelectionModalComponent, {
        width: '600px',
        height: 'auto',
        disableClose: true,
      });

      dialogRef.afterClosed().subscribe((selectedOption: UserTypeEnum) => {
        
        if (selectedOption === UserTypeEnum.internal) {
            // Open interuser registration form modal here
            this.dialog.open(InteruserRegistrationFormComponent, {
            width: '600px',
            minHeight: '600px',
            disableClose: true,
            panelClass: 'custom-dialog-container',
            });
        } else if (selectedOption === UserTypeEnum.external) {
          this.openExtRegistration.emit(true);
          // this.dialog.open(ExternalUserRegistrationComponent, {
          //   width: '600px',
          //   disableClose: true,
          // });
        }
      });
    }
  }
}
